"use client";

import React, { ReactElement } from "react";

import HelpOverlayButton from "@/app/shared-components/help-overlay-button/help-overlay-button";
import Logo from "@/components/molecules/logo-component/logo";
import useGtmPageView from "@/hooks/gtm/use-gtm-page-view";
import useCustomPageTracking from "@/hooks/page-tracking/use-custom-page-tracking";
import useUpdateProgressBar from "@/hooks/progress/use-update-progress-bar";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";

interface ClientComponentProps {
  content: ReactElement;
  pageName: string;
}

function UnableToCreateRenewalWrapper({
  content,
  pageName,
}: Readonly<ClientComponentProps>) {
  const [isdesktop, isReady] = useMediaQuery("(min-width: 600px)");

  useUpdateProgressBar(-1);

  const { pageReferrer, pageUrl, pageTitle } = useCustomPageTracking(pageName);

  useGtmPageView({
    userId: "",
    quoteId: "",
    pageReferrer,
    pageUrl,
    pageTitle,
  });

  if (!isReady) return null;

  return (
    <div
      data-testid="mta-decline-wrapper-id"
      className=" bg-surface-neutral-option-2 "
    >
      <div className="w-full h-full">
        <div className="min-h-screen bg-surface-neutral-option-2">
          <div className="max-w-[1200px] mx-auto my-0 w-[100%] relative">
            <main className="md:pt-spacing-xl lg:pt-spacing-xxl md:pb-spacing-xxl pt-spacing-m pb-spacing-m ">
              <div
                className=" md:gap-spacing-l gap-spacing-m xl:mx-auto lg:mx-[72px] 
      md:mx-[48px] mx-[24px] relative"
              >
                <div className="bg-dark-surface-accent-1-primary rounded-radius-xxl ">
                  <div className=" flex flex-col h-full">
                    <div className="text-surface-neutral-option-2 relative">
                      <HelpOverlayButton />
                      <Logo
                        color="white"
                        heightClass="h-[80px]"
                        size="xl"
                        showondesktop={isdesktop.toString()}
                      />
                    </div>
                    {content}
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnableToCreateRenewalWrapper;
